import { IOfferzBuyOptions } from "@/types/product";
import { create } from "zustand";

interface ProductState {
  qty: number | "";
  ownAmount: number | "";
  error: boolean;
  helperText: string;
  inputValues: Record<string, string | number>;
  apiErrors: any;
  minAmount: number;
  maxAmount: number;
  availableOptions: IOfferzBuyOptions[];

  resetQty: () => void;
  resetOwnAmount: () => void;
  setQty: (value: number | "") => void;
  setOwnAmount: (value: number | "") => void;
  setError: (value: boolean) => void;
  setHelperText: (value: string) => void;
  setInputValues: (id: string, value: string | number) => void;
  setApiErrors: (value: any) => void;
  setMinAmount: (value: number) => void;
  setMaxAmount: (value: number) => void;
  setAvailableOptions: (options: IOfferzBuyOptions[]) => void;
  reset: () => void;
}

export const useProductStore = create<ProductState>((set) => ({
  qty: 1,
  ownAmount: "",
  error: false,
  helperText: "",
  inputValues: {},
  apiErrors: {},
  minAmount: 0,
  maxAmount: Infinity,
  availableOptions: [],

  setQty: (qty) => set({ qty }),
  setOwnAmount: (ownAmount) => set({ ownAmount }),
  setError: (error) => set({ error }),
  setHelperText: (text) => set({ helperText: text }),
  setInputValues: (id, value) =>
    set((state) => ({
      inputValues: {
        ...state.inputValues,
        [id]: value,
      },
    })),
  setApiErrors: (errors) => set({ apiErrors: errors }),
  setMinAmount: (min) => set({ minAmount: min }),
  setMaxAmount: (max) => set({ maxAmount: max }),
  setAvailableOptions: (options) => set({ availableOptions: options }),

  resetQty: () => set({ qty: 1 }),
  resetOwnAmount: () => set({ ownAmount: "" }),
  reset: () =>
    set({
      qty: "",
      ownAmount: "",
      error: false,
      helperText: "",
      inputValues: {},
      apiErrors: {},
      minAmount: 0,
      maxAmount: Infinity,
      availableOptions: [],
    }),
}));
